<template>
<div class="flex-center">
  <div class="dashboard">
    <el-row>
    <el-col :xs="24" :md="12">
      <nxs-admin-terms />
    </el-col>
    <el-col :xs="24" :md="12">
      <nxs-admin-org-values />
    </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <nxs-dist-lists />
      </el-col>
    </el-row>
  </div>
  </div>
</template>

<style scoped>
.dashboard {
  max-width: 56em;
  width: 100%;
}
.flex-center {
  padding: 1.2em;
  display:flex;
  justify-content: center;
}
</style>
<script>
import nxsAdminTerms from './Terms.vue';
import nxsAdminOrgValues from './OrgValues.vue';
import nxsDistLists from './DistributionLists.vue';

export default {components: {nxsAdminTerms, nxsAdminOrgValues, nxsDistLists}}
</script>
